import { useEffect, useState } from "react";

import "./loader.css";

import { tw } from "@/utils";
import { ClassValue } from "clsx";

interface ILoaderProps {
  className?: ClassValue;
}

export default function Loader({ className }: ILoaderProps) {
  const opacityArr = [
    0.2, 0.3333, 0.4667, 0.6, 0.7333, 0.8667, 1.0, 0.8667, 0.7333, 0.6, 0.4667,
    0.3333,
  ];
  const [firstItemIndex, setFirstItemIndex] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFirstItemIndex((old) => old + 1);
    }, 100);
    setTimeout(() => clearInterval(interval), 1200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={"loader"}>
      {new Array(12).fill(0).map((_, idx) => (
        <div
          key={idx}
          aria-label="로딩중"
          className={tw("bg-gray-g100", className)}
          style={{ opacity: opacityArr[(idx - firstItemIndex + 12) % 12] }}
        />
      ))}
    </div>
  );
}
